import { render, staticRenderFns } from "./reportsFull.vue?vue&type=template&id=3b4346be&scoped=true"
import script from "./reportsFull.vue?vue&type=script&lang=js"
export * from "./reportsFull.vue?vue&type=script&lang=js"
import style0 from "./reportsFull.vue?vue&type=style&index=0&id=3b4346be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4346be",
  null
  
)

export default component.exports